var unknownProp = null;
var numericProp = [Number, String];
var truthProp = {
  type: Boolean,
  "default": true
};

var makeRequiredProp = function makeRequiredProp(type) {
  return {
    type: type,
    required: true
  };
};

var makeArrayProp = function makeArrayProp() {
  return {
    type: Array,
    "default": function _default() {
      return [];
    }
  };
};

var makeNumberProp = function makeNumberProp(defaultVal) {
  return {
    type: Number,
    "default": defaultVal
  };
};

var makeNumericProp = function makeNumericProp(defaultVal) {
  return {
    type: numericProp,
    "default": defaultVal
  };
};

var makeStringProp = function makeStringProp(defaultVal) {
  return {
    type: String,
    "default": defaultVal
  };
};

export { makeArrayProp, makeNumberProp, makeNumericProp, makeRequiredProp, makeStringProp, numericProp, truthProp, unknownProp };